import {defineMessages} from 'react-intl';

export default defineMessages({
	signInEmailError: {
		id: 'popups.newsletter.signIn.emailError',
		defaultMessage: 'The email address field is mandatory',
	},
	mandatory: {
		id: 'popups.newsletter.signIn.mandatory',
		defaultMessage: '* Mandatory field',
	},
	signInEmailPlaceholder: {
		id: 'popups.newsletter.signIn.emailPlaceholder',
		defaultMessage: 'Your Email',
	},
	invalidEmail: {
		id: 'popups.newsletter.signIn.invalidEmail',
		defaultMessage: 'Email field is incorrect. Check again',
	},
	signInPrivacyPolicy: {
		id: 'popups.newsletter.signIn.signupPrivacyPolicy',
		defaultMessage: '*I have read the <privacy>Privacy Policy</privacy> and consent to the processing of my personal data for marketing purposes (Newsletters, News and Promotions)',
	},
	signInCtaAfterClick: {
		id: 'popups.newsletter.signIn.ctaAfterClick',
		defaultMessage: 'Subscribe',
	},
	checkboxPrivacy: {
		id: 'popups.newsletter.checkboxPrivacy',
		defaultMessage:
			'Consent for profiling',
	},
	signInSuccess: {
		id: 'popups.newsletter.signIn.success',
		defaultMessage: 'You’re successfully subscribed to our Newsletter',
	},
	signInAlreadySubscribed: {
		id: 'popups.newsletter.signIn.alreadySubscribed',
		defaultMessage: 'You already subscribed to the newsletter',
	},
	signInFailure: {
		id: 'popups.newsletter.signIn.failure',
		defaultMessage: 'Unexpected error',
	},
});
